import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

import { BaseTFootProps, BaseTFoot } from '../../base';

import classes from '../styles/standard-table.module.scss';

export const TFoot: FunctionComponent<BaseTFootProps> = (props) => {
  const { children, ...otherProps } = props;
  return (
    <BaseTFoot
      {...otherProps}
      className={classnames('standardTfoot', classes.tfoot, props.className)}
    >
      {children}
    </BaseTFoot>
  );
};
